<template>
  <footer>
<el-link href="https://beian.miit.gov.cn/" target="_blank">备案号:湘ICP备2022022791号-1</el-link>
</footer>
</template>

<script>
export default {
  name: 'ohsFooter',
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
footer {
  text-align: center;
}
</style>
